import axios from 'axios';

// const baseUrl = 'http://ec2-35-168-11-169.compute-1.amazonaws.com:80/CompCal';
const baseUrl = 'https://api.1calendar.devaltus.com';



export const getLoginInfo = async (token) => {
  try {
    // const response = await axios.get(`${baseUrl}/auth/get-login`);
    const response = axios({
      method: 'get',
      url: `${baseUrl}/auth/get-login`,
      // headers: {
      //     'Authorization': `Bearer ${token}`
      // }
    })
    console.log('getLoginInfo res--> ', response);
  } catch (error) {
    console.error(error);
  }
}

export const getCookie = async (token) => {
  try {
    const response = await axios.get(`${baseUrl}/auth/get-cookie`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },

    }, { withCredentials: true });

    console.log('getCookie res--> ', response);
  } catch (error) {
    console.error(error);
  }

}

export const getConfig = async (token) => {
  try {
    const response = await axios.get(`${baseUrl}/user/get-config`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          // Cookie: 'idtoken=myidtoken'
        },

      }, { withCredentials: true }
    );

    console.log('getConfig res--> ', response);
    return response?.data?.calendars;
  } catch (error) {
    console.error(error);
  }
  

}


export const validateTrinetKeys = async (trinetData) => {
  try {
    const response = await axios.post(`${baseUrl}/validators/validate-trinet-keys`,
      { ...trinetData }, { withCredentials: true });
    // console.log('validateTrinetKeys res--> ', response);
    if (response.status === 200) {
      return {valid: true};
    } else{
      return {valid: false, error: response.message};
    }
  } catch (error) {
    console.error("Error in validateTrinetKeys:: ", error);
    return {valid: false, error: "Trinet details not found!"};
  }
}

export const storeNewConfig = async (configData, token) => {
  try {
    const response = await axios.post(`${baseUrl}/user/store-new-config`, { ...configData }, {
      headers: {
        Authorization: `Bearer ${token}`,

      },
    }, { withCredentials: true }

    );
    // console.log('storeNewConfig res--> ', response);
    if (response.status === 200) {
      
      return await getConfig(token);
    }
  } catch (error) {
    console.error(error);
  }

}